import axios from 'axios'
import { URL } from '../../config'
import { getRequest, putRequest, postRequest } from '../../utils/functions/httpRequest'
import { types } from '.'

const seasonURL = URL.season

export function fetchActiveSeasons() {
	const url = `${seasonURL}/active`
	const request = getRequest(url)

	return {
		type: types.Season.FETCH_ACTIVE_SEASONS,
		payload: request
	}
}

export function fetchNewSeason() {
	const url = `${seasonURL}/season`
	const request = getRequest(url)

	return {
		type: types.Season.FETCH_NEW_SEASON,
		payload: request
	}
}

export function fetchSeasonDates(seasonId){
	const url = `${seasonURL}/${seasonId}/dates`
	const request = getRequest(url)
	
	return {
		type: types.Season.FETCH_SEASON_DATES,
		payload: request
	}
}
export function savingData() {
	return {
		type: types.Season.SAVING_DATA,
	}
}
export function savingOilConditions() {
	return {
		type: types.Season.SAVING_SEASON_OIL,
	}
}
export function savingSeasonSetup() {
	return {
		type: types.Season.SAVING_SEASON_SETUP,
	}
}
export function saveSeasonDates(seasonId,seasondates) {
	const url = `${seasonURL}/${seasonId}/dates`
	const request = putRequest(url,seasondates)
	
	return {
		type: types.Season.SAVE_SEASON_DATES,
		payload: request
	}
}
export function triggerSeason(seasonId, season,city,state,date) {
	const url = `${seasonURL}/${seasonId}/${city}/${state}/${date}/trigger`
	const request = putRequest(url,season)
	
	return {
		type: types.Season.TRIGGER_SEASON,
		payload: request
	}
}
export function saveSeasonOilConditions(seasonId,seasonoilconditions){
	const url = `${seasonURL}/${seasonId}/oilconditions`
	const request = putRequest(url,seasonoilconditions)
	
	return {
		type: types.Season.SAVE_SEASON_OILCONDITIONS,
		payload: request
	}
}
export function saveSeasonSetup(seasonId,seasonsetup) {
	const url = `${seasonURL}/${seasonId}/setup`
	const request = putRequest(url,seasonsetup)
	
	return {
		type: types.Season.SAVE_SEASON_SETUP,
		payload: request
	}
}
export function saveSeasonDivisions(seasonId,seasonDivisions, minRequiredDeposit) {
	const url = `${seasonURL}/${seasonId}/${minRequiredDeposit}/divisions`
	const request = putRequest(url,seasonDivisions)
	
	return {
		type: types.Season.SAVE_SEASON_DIVISION,
		payload: request
	}
}
export function addSeasonDivision(seasonId,seasonDivision) {
	const url = `${seasonURL}/${seasonId}/division`
	const request = postRequest(url,seasonDivision)
	
	return {
		type: types.Season.ADD_SEASON_DIVISION,
		payload: request
	}
}
export function setAddDivisionMode()
{
	return {
		type: types.Season.ADD_DIVISION_MODE,
	}
}
export function addingSeasonDivision() {
  return {
		type: types.Season.ADDING_SEASON_DIVISION,
	}
}
export function savingSeasonDivisions() {
	return {
		type: types.Season.SAVING_SEASON_DIVISION,
	}
}
export function deleteSeasonDivision(id) {
  const url = `${seasonURL}/removedivision`
  const request = postRequest(url, { id:id })

  return {
    type: types.Season.DELETE_SEASON_DIVISION,
    payload: request
  }
}
export function saveSeasonFee(seasonId,seasonFee) {
	const url = `${seasonURL}/${seasonId}/fees`
	const request = putRequest(url,seasonFee)
	
	return {
		type: types.Season.SAVE_SEASON_FEE,
		payload: request
	}
}
export function saveSeasonParticipant(seasonId,seasonparticipant) {
	const url = `${seasonURL}/${seasonId}/participant`
	const request = axios.put(url,seasonparticipant)
	
	return {
		type: types.Season.SAVE_SEASON_PARTICIPANT,
		payload: request
	}
}
export function savingSeasonParticipant() {
	return {
		type: types.Season.SAVING_SEASON_PARTICIPANT,
	}
}
export function saveEmailSettings(seasonId,seasontemplate) {
	const url = `${seasonURL}/emailsettings`;
	const request = putRequest(url,seasontemplate)
	
	return {
		type: types.Season.SAVE_EMAIL_SETTINGS,
		payload: request
	}
}

export function savingEmailSettings() {
	return {
		type: types.Season.SAVING_EMAIL_SETTINGS,
	}
}
export function resetSetupSettings() {
	return {
		type: types.Season.RESET_SETUP_SETTINGS
	}
}
export function resetDatesSettings() { 
	return {
		type: types.Season.RESET_DATES_SETTINGS
	}
}
export function resetOilSettings() {
	return {
		type: types.Season.RESET_OIL_SETTINGS
	}
}
export function resetParticipantSettings() {
  return {
		type: types.Season.RESET_PARTICIPANT_SETTINGS
	}
}
export function resetTemplateSettings() {
  return {
		type: types.Season.RESET_TEMPLATE_SETTINGS
	}
}


// WEBPACK FOOTER //
// ./src/redux/actions/seasonActions.js